import React from 'react';
import * as Yup from 'yup';

export const ContentModalAddStringStepValidatorSchema = Yup.object().shape({
    value: Yup.string()
        .required('required'),
});